import { useState } from 'react';
import type { OptionType } from '../types/forms.type';
import { All } from '../types/enums';
import { Snapshot } from '../types/core.type';

export default function useSnapshotWardFilters(snapshot:Snapshot) {
  const [selectedSnapshot, setSelectedSnapshot] = useState<OptionType>({
    label: snapshot.formattedSnapshot,
    value: snapshot.rawSnapshot
  });
  const [selectedWard, setSelectedWard] = useState<OptionType>({ label: All.label, value: All.value });
  const [selectedLocalAuthority, setSelectedLocalAuthority] = useState<OptionType>({ label: All.label, value: All.value });
  const handleSnapshotChange = (option: OptionType) => {
    setSelectedSnapshot(
      option.value
        ? option
        : { label: snapshot.formattedSnapshot, value: snapshot.rawSnapshot },
    );
  };
  const handleWardChange = (option: OptionType) => {
    if (!option?.value) {
      setSelectedWard({ label: All.label, value: All.value });
      return;
    }
    setSelectedWard(option);
  };
  const handleLocalAuthorityChange = (option: OptionType) => {
    if (!option?.value) {
      setSelectedLocalAuthority({ label: All.label, value: All.value });
      return;
    }
    setSelectedLocalAuthority(option);
  };
  return {
    selectedSnapshot,
    selectedLocalAuthority,
    selectedWard,
    handleSnapshotChange,
    handleLocalAuthorityChange,
    handleWardChange,

  };
}
